import { useScoreSimulatorExp } from 'pages_ScoreSimulator_hooks/ScoreSimulatorExp.hook';
import ScoreSimulatorBannerModuleView from './ScoreSimulatorBannerModuleView.js';

const ScoreSimulatorBannerModuleController = props => {
  const isPotential = props?.isPotential;
  const scoreSimulatorExp = useScoreSimulatorExp();
  if (scoreSimulatorExp?.enabled && isPotential) {
    return <ScoreSimulatorBannerModuleView {...props} />;
  } else {
    return <></>;
  }
};

export default ScoreSimulatorBannerModuleController;
